import styled from 'styled-components';

export const Container = styled.div`
  --color-page-secondary: #ff8723;
  --color-range-ball: #ff8723;

  .simulator-section {
    background-color: #f2f2f2;
    justify-content: center;
    display: flex;
    padding: 5rem 2rem;

    @media (max-width: 768px) {
      background-color: #f8f8f8;
    }

    .main-button {
      background: #ff8723;
      max-width: 212px;
      width: 100%;
      text-align: center;
      margin: 3rem auto;
    }

    .text-dark {
      color: #e0a730;
    }

    .form-caulate-discount {
      text-align: left;
    }

    .text-page {
      h2 {
        font-size: 3rem;
        font-weight: 400;

        b {
          color: #000;
        }
      }

      p {
        font-weight: 300;
        font-size: 1.2rem;
      }

      @media (max-width: 800px) {
        h2 {
          font-size: 2rem;
        }
      }
    }

    .opening-banner-business {
      .text-opening {
        .content-buttons {
          a {
            &:first-child {
              background-color: #008ab5;
              border-color: #008ab5;
            }
          }
        }
      }
    }

    .section-swipper-clients,
    .section-swipper-partners {
      background-color: #fff;

      .clients-bg-left svg {
        stroke: #e4e0e0;
        stroke-width: 3px;
      }
    }

    .section-swipper-soluctions {
      padding: 50px 0 100px;

      @media (max-width: 800px) {
        padding: 50px 0;
      }

      .selectors-section {
        ul.selections {
          li {
            button {
              h2 {
                color: #cd9efa;
              }
            }
          }

          li:hover {
            background-color: rgba(0, 0, 0, 0.05);

            button {
              h2 {
                color: #9a3ef5;
              }
            }

            @media (max-width: 600px) {
              background-color: #fff;
              box-shadow: 0px 0px 50px 2px rgba(0, 0, 0, 0.1);
            }
          }

          li.active,
          &.active:hover {
            background-color: white;
            box-shadow: 0px 0px 50px 2px rgba(0, 0, 0, 0.1);

            button {
              h2 {
                color: #9a3ef5;
              }
            }
          }
        }
      }
    }

    .partnerships-section {
      padding: 0 0 250px;

      @media (max-width: 769px) {
        padding: 80px 0;
      }

      @media (max-width: 600px) {
        padding: 0 0 50px;
      }

      .partnerships-wrapper {
        .partnerships-content {
          align-items: stretch;
          width: 100%;
          justify-content: space-between;

          .mockup-mobile-phone {
            max-width: 400px;
            width: 100%;
            min-height: 550px;
            margin: 0px 0px 0px 40px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }

          .content-text-rigth {
            max-width: 680px;
            padding-bottom: 30px;
            position: relative;

            h2 {
              font-weight: 700;
              color: #005b90;
              letter-spacing: 0.5px;
            }

            h3 {
              line-height: 1.6;
              font-weight: 300;
            }

            .mockup-desktop-colab {
              width: 1150px;
              display: block;
              height: 650px;
              position: absolute;
              bottom: 0;
              right: 0;
              left: auto;
              top: auto;
              z-index: 1;
              transform: translate(22.5%, 60%);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            }
          }

          @media (max-width: 769px) {
            .content-text-rigth {
              color: #e80e8a;
              position: initial;
              max-width: 400px;
              padding-bottom: 30px;

              h2 {
                font-size: 1.5rem;
              }

              p {
                font-size: 1rem;
              }

              .mockup-desktop-colab {
                background-size: 100%;
                width: 350px;
                left: 0;
                transform: translate(0, -50%);
                top: 50%;
              }
            }

            .mockup-mobile-phone {
              max-width: 320px;
              min-height: 100px;
              margin: 0px 0px 0px 10px;
              z-index: 2;
              background-size: 90px;
              background-position: left;
            }
          }

          @media (max-width: 600px) {
            flex-flow: column;

            .content-text-rigth {
              color: #e80e8a;
              position: relative;

              h2 {
                font-size: 1.5rem;
              }

              p {
                font-size: 1.2rem;
              }

              .mockup-desktop-colab {
                background-size: contain;
                width: 100%;
                height: 300px;
                transform: translate(0%, 100%);
                left: auto;
                top: auto;
              }
            }

            .mockup-mobile-phone {
              order: 2;
              margin: 0px;
              min-height: 250px;
              transform: translate(10%, 20%);
              z-index: 2;
            }

            .content-text-rigth {
              order: 1;
              padding: 0;
            }
          }
        }
      }
    }
  }

  .simulator-section {
    position: relative;
    overflow: hidden;

    @media (max-width: 768px) {
      padding: 30px 17px 0;
    }

    .brand-bg-left,
    .brand-bg-right {
      position: absolute;

      svg {
        width: 100%;
        display: block;
        max-width: 900px;
        fill: darken(#e80e8a, 10%);
        stroke: darken(#e80e8a, 10%);
        stroke-width: 2;
        stroke-miterlimit: 10;
        opacity: 0.3;
      }
    }

    .brand-bg-left {
      left: 0;
      top: 0;
      max-width: 900px;
      width: 100%;
      transform: translate(-40%, -5%) rotate(180deg);
    }

    .brand-bg-right {
      right: 0;
      bottom: 0;
      max-width: 900px;
      width: 100%;
      transform: translate(40%, 40%);
    }

    .cadaster-section {
      .content-text-rigth {
        color: #e80e8a;
        max-width: 1170px;
        padding-bottom: 30px;
        width: 100%;
        text-align: center;

        h2 {
          margin-top: 10px;
        }

        h2 {
          font-size: 2.2rem;
          font-weight: 500;

          b {
            font-weight: 800;
            color: #ff671f;
          }
        }

        p {
          font-size: 1.5rem;

          b {
            font-weight: 800;
          }
        }
      }
    }

    .simulator-content {
      flex-flow: wrap;

      .content-text-rigth {
        max-width: 1170px;
        padding-bottom: 30px;
        width: 100%;
        text-align: center;

        h2 {
          font-family: Arial, sans-serif;
          font-weight: normal;
          font-size: 30px;
          line-height: 34px;
          text-align: center;
          color: #c40023;
        }

        p {
          font-size: 1.5rem;

          b {
            font-weight: 800;
          }
        }
      }

      .total-calc-mobile {
        width: 100vw;
        height: 80px;
        background: #FF8723;
        display: none;
        color: white;
        align-items: center;
        padding: 21px 24px;
        justify-content: center;
        margin-top: 27px;

        > p {
          color: white;
          font-family: 'Roboto', sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
          margin: 0 40px 0 0;
          flex: 1;

          &.money-calculated {
            font-size: 32px;
            margin: 0;
            flex: none;
          }
        }
      }

      .wrapper-form {
        align-items: stretch;
        display: flex;
        padding: 0px 70px;

        @media (max-width: 1200px) {
          padding: 0px;
        }

        @media (max-width: 768px) {
          display: -webkit-box;
          overflow: auto;
        }

        @media (max-width: 500px) {
          display: contents;
        }

        .total-calc {
          color: #fff;
          width: 100%;
          max-width: 426px;
          margin-left: 20px;
          padding: 0 30px;
          text-align: center;
          background: #c40023;
          display: flex;
          flex-flow: column;
          justify-content: center;
          position: relative;

          @media (max-width: 768px) {
            display: none;
          }

          p {
            text-align: center;
            width: 85%;
            margin: auto;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 36px;
          }

          @media (max-width: 400px) {
            p {
              font-size: 1.2rem;
            }
          }

          @media (max-width: 330px) {
            padding: 15px 47px;
          }

          .money-calculated {
            font-size: 4.5rem;
            text-align: center;
            width: 90%;
            margin: 10px auto;
            height: auto;
            line-height: 1;
            font-weight: 700;
            padding: 14px 0px;
          }

          .strong {
            font-size: 1.2em;
            font-weight: 800;
          }
        }

        .form-calc {
          margin-right: 20px;
          padding-right: 20px;
          max-width: 700px;
          width: 100%;

          @media (max-width: 1204px) {
            padding-right: 0px;
            margin-right: 0px;
          }

          .form-caulate-discount {
            p {
              color: #666765;
              font-style: normal;
              font-weight: normal;
              font-size: 18px;
              margin: 0 31px 18px;

              @media (max-width: 450px) {
                margin: 0 13px 18px;
              }
            }

            .input-range-wrapper {
              display: flex;
              flex-flow: wrap;
              justify-content: space-between;
              margin: 30px;

              @media (max-width: 450px) {
                margin: 0 13px 13px;
              }

              label {
                width: 100%;
                color: #000;
                font-size: 1.125rem;
                font-weight: 700;
                margin: 0 0 5px;
              }

              input[type='range'] {
                width: 70%;
                padding: 0;
                color: #000000;
                font-weight: 400;

                @media (max-width: 769px) {
                  width: 65%;
                }
              }

              input[type='range'] {
                margin: 13px 0 0 0;
                outline: none;
                padding: 0;
                height: 8px;
                background-color: #cccccc;
                background-image: -webkit-gradient(
                  linear,
                  50% 0%,
                  50% 100%,
                  color-stop(0%, var(--color-page-secondary)),
                  color-stop(100%, var(--color-page-secondary))
                );
                background-image: -webkit-linear-gradient(var(--color-page-secondary), var(--color-page-secondary));
                background-image: -moz-linear-gradient(var(--color-page-secondary), var(--color-page-secondary));
                background-image: -o-linear-gradient(var(--color-page-secondary), var(--color-page-secondary));
                background-image: linear-gradient(var(--color-page-secondary), var(--color-page-secondary));
                background-size: 50% 100%;
                background-repeat: no-repeat;
                border-radius: 10px;
                cursor: pointer;
                -webkit-appearance: none;
              }

              input[type='range']::-webkit-slider-runnable-track {
                box-shadow: none;
                border: none;
                background: transparent;
                -webkit-appearance: none;
              }

              input[type='range']::-moz-range-track {
                box-shadow: none;
                border: none;
                background: transparent;
              }

              input[type='range']::-moz-focus-outer {
                border: 0;
              }

              input[type='range']::-webkit-slider-thumb {
                width: 25px;
                height: 25px;
                border: 0;
                background: var(--color-range-ball);
                border-radius: 100%;
                box-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.1);
                -webkit-appearance: none;
              }

              input[type='range']::-moz-range-thumb {
                width: 25px;
                height: 25px;
                border: 0;
                background: var(--color-range-ball);
                border-radius: 100%;
                box-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.1);
              }

              .value-discount {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 22%;
                background: transparent;
                color: #666765;
                text-align: center;
                font-size: 1rem;
                padding: 0;
                height: 35px;
                font-weight: 700;
                background: white;

                span {
                  width: 100%;
                  text-align: right;
                  height: 22px;
                }

                @media (max-width: 769px) {
                  width: 30%;
                }
              }

              input[type='text'],
              input[type='number'] {
                border: none;
                background-color: transparent;
                width: 100%;
                padding: 0;
                color: #000000;
                font-weight: 500;
                text-align: center;
                font-size: 1rem;
              }

              &.sifra-mini {
                .value-discount {
                  span {
                    font-weight: normal;
                    width: 75%;

                    @media (max-width: 600px) {
                      width: 60%;
                    }
                  }
                }
              }
            }
          }
        }
      }

      @media (max-width: 768px) {
        margin: 0;

        .content-text-rigth {
          h1 {
            font-family: 'Arial', sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
          }
        }
      }
    }

    &.active-animate {
      .simulator-content {
        .wrapper-form {
          display: flex;

          .total-calc {
            transform: translate(0%, 0%);
            opacity: 0.1;
          }
        }
      }
    }
  }

  .simulator-section {
    .cadaster-section {
      overflow: hidden;

      .content-text-rigth {
        color: #e80e8a;
        padding-bottom: 30px;
        width: 100%;
        text-align: center;

        h2 {
          font-size: 2.2rem;
          font-weight: 500;

          b {
            font-weight: 800;
            color: #ff671f;
          }
        }

        p {
          font-size: 1.5rem;

          b {
            font-weight: 800;
          }
        }
      }

      .container-box {
        height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 0px 100px;

        @media (max-width: 600px) {
          height: 100%;
          flex-direction: column;
          padding: 0px 50px;
        }

        .box-cadaster {
          height: 70%;
          width: 26%;
          background-size: cover;
          background-position: center;
          text-align: center;

          @media (max-width: 1024px) {
            width: 30%;
          }

          @media (max-width: 600px) {
            height: 100%;
            width: 100%;
            margin: 15px 0px;
          }

          .box-content {
            padding: 100px 25px 0px 25px;
            display: flex;
            flex-direction: column;
            height: 85%;
            justify-content: center;
            text-align: left;

            h2 {
              color: white;
              font-weight: bold;
              font-size: 1.7em;
              padding-bottom: 5px;
            }

            span {
              height: 5px;
              width: 20px;
            }

            p {
              padding-top: 5px;
              color: white;
            }
          }

          .box-link {
            height: 15%;
            padding: 15px;

            a {
              padding: 25px;
              color: white;
              font-weight: bold;

              @media (max-width: 1024px) {
                padding: 0px;
              }
            }
          }

          .link-company {
            background-color: #00747b;
          }

          .link-you {
            background-color: #930f55;
          }

          .link-business {
            background-color: rgb(255, 166, 29);
          }
        }
      }
    }

    .section-cadaster-articles {
      background-color: #e80e8a;
    }

    .explore-network_section {
      .section-swipper-clients {
        .swiper-container {
          overflow: hidden;
        }
      }
    }

    @media (max-width: 768px) {
      .hide-on-mobile {
        display: none;
      }

      .total-calc-mobile {
        display: flex !important;
      }
    }
  }
`;
